import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Button from '../../Elements/buttons/Button'
import CustomInfoModal from '../../Elements/modal/CustomInfoModal'
import { TseWarningText, TseWarningWrapper } from './index.styled'
import { setAppModal } from '../../../redux/action/system'
import { selectCompanyData, selectContainsAnyRole } from '../../../redux/selector/system'

const EVENT_Z_INDEX = 992

const TseInvalidDataWarningModal = React.memo(() => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const location = useLocation()
	const dispatch = useDispatch()
	const isOpen = useSelector(store => store.system.modal.tseInvalidDataModalShow)
	const invalidDataTseStatus = useSelector(store => store.tse.config?.status === 'NOT_ENOUGH_DATA')
	const hasRoleSettingsWrite = useSelector(selectContainsAnyRole(['PROGRAM_SETTINGS_WRITE']))
	const isLocatedInAustria = useSelector(selectCompanyData('countryCode')) === 'AUT'
	const shouldOpenAfterLogIn = location?.state?.isLogIn && hasRoleSettingsWrite && invalidDataTseStatus && isLocatedInAustria

	useEffect(() => {
		if (shouldOpenAfterLogIn) {
			dispatch(setAppModal({ tseInvalidDataModalShow: true }))
		}
	}, [shouldOpenAfterLogIn, dispatch])

	const close = useCallback(() => {
		dispatch(setAppModal({ tseInvalidDataModalShow: false }))
	}, [dispatch])

	const navigateToSettings = useCallback(() => {
		navigate('/settings/program/company-data', { state: { scrollToTse: true } })
		close()
	}, [close, navigate])

	return (
		<CustomInfoModal isOpen={isOpen}
			title={t('Modal.tse_warning_modal.title')}
			close={close}
			modalColor="orange"
			zIndex={EVENT_Z_INDEX}
			button={<>
				<Button icon="settings-2" onClick={navigateToSettings} text={t('Modal.tse_warning_modal.buttonSettingText')} color="gray" />
				<Button icon="checkmark" onClick={close} tabIndex="1" text={t('buttons.controls.ok')} color="green" keyButton="F2" />
			</>}>
			<TseWarningWrapper>
				<TseWarningText>
					{t('Modal.tse_warning_modal.text')}
					<span onClick={navigateToSettings}>{t('Modal.tse_warning_modal.linkText')}</span>
				</TseWarningText>
			</TseWarningWrapper>
		</CustomInfoModal>
	)

})

TseInvalidDataWarningModal.displayName = 'TseInvalidDataWarningModal'
export default TseInvalidDataWarningModal
